import { Component, ElementRef, HostBinding, Input, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'app-widget-card-wrapper',
  templateUrl: './widget-card-wrapper.component.html',
  styleUrls: ['./widget-card-wrapper.component.scss'],
})
export class WidgetCardWrapperComponent implements OnInit {
  @Input() title: string = '';
  @Input() subTitle: string = '';
  private _hide: boolean = false;
  private hasBeenVisible: boolean = false;
  private _doubleWidth: boolean = false;
  isRendered: boolean = true;

  @ViewChild('cardWrapper', { static: false })
  private cardWrapper?: ElementRef<HTMLDivElement>;

  @Input()
  set hide(value: boolean) {
    this._hide = !!value;

    if (!this._hide) {
      this.isRendered = true;
      this.hasBeenVisible = true;
      return;
    }

    if (!this.hasBeenVisible) {
      this.isRendered = false;
    }
  }

  get hide(): boolean {
    return this._hide;
  }

  get shouldPlayFadeOut(): boolean {
    return this.hide && this.hasBeenVisible;
  }

  @Input()
  set doubleWidth(value: boolean) {
    this._doubleWidth = !!value;
  }

  get doubleWidth(): boolean {
    return this._doubleWidth;
  }

  @HostBinding('class.double-width')
  get hostDoubleWidth(): boolean {
    return this.doubleWidth;
  }

  ngOnInit(): void {
    if (!this.hide) {
      this.hasBeenVisible = true;
    }
  }

  onAnimationEnd(event: AnimationEvent): void {
    if (!this.shouldPlayFadeOut || !this.cardWrapper || event.target !== this.cardWrapper.nativeElement) {
      return;
    }

    if (event.animationName === 'fadeOut') {
      this.isRendered = false;
    }
  }
}
